import { type Tag } from '@hungryroot/rest';

import { tags } from '../tags';

/**
 * A product is considered "seafood" when it carries the "BFL L1 - Seafood" tag
 * (`tags.SeafoodBflL1`). We key off this tag rather than
 * `primary_category_name`, because the catalog groups meat and seafood into a
 * single "Meat + Seafood" category — so a beef or chicken product shares that
 * category name and must NOT be treated as seafood.
 */
export function isSeafoodProduct(
  productTags: Pick<Tag, 'id'>[] | undefined | null
): boolean {
  return productTags?.some((tag) => tag.id === tags.SeafoodBflL1) ?? false;
}
